var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Modal } from "antd";
import { observer } from "mobx-react-lite";
import React from "react";
import { useOpenDashApp, useTranslation } from "../..";
export const VersionDialog = observer(function VersionDialog() {
    const t = useTranslation();
    const app = useOpenDashApp();
    return (React.createElement(Modal, { title: t("opendash:ui.version"), okText: t("opendash:ui.version_force_update"), cancelText: t("opendash:ui.close"), open: app.ui2.versionDialogOpen, children: t("opendash:ui.version_build", { version: app.ui2.version }), okType: "danger", onOk: () => __awaiter(this, void 0, void 0, function* () {
            try {
                if ("serviceWorker" in navigator) {
                    const reg = yield navigator.serviceWorker.getRegistration();
                    if (reg) {
                        yield reg.unregister();
                    }
                }
            }
            catch (error) {
                console.log(error);
            }
            try {
                if (window.caches) {
                    const caches = window.caches;
                    const cacheKeys = yield caches.keys();
                    for (const cacheKey of cacheKeys) {
                        yield caches.delete(cacheKey);
                    }
                }
            }
            catch (error) {
                console.log(error);
            }
            try {
                window.localStorage.clear();
            }
            catch (error) {
                console.log(error);
            }
            window.location.reload();
        }), onCancel: () => {
            app.ui2.hideVersionDialog();
        } }));
});
//# sourceMappingURL=VersionDialog.js.map